import React, { useMemo, useState } from "react";
import { FiPlus, FiMinus, FiTrash2, FiShoppingCart } from "react-icons/fi";

export default function POS() {
  const [cart, setCart] = useState([]);
  const [product, setProduct] = useState("");
  const [quantity, setQuantity] = useState(1);

  // ---------- ADD ----------
  const addToCart = () => {
    if (!product.trim() || quantity <= 0) return;

    setCart((prev) => {
      const exist = prev.find(
        (i) => i.name.toLowerCase() === product.toLowerCase()
      );

      if (exist) {
        return prev.map((i) =>
          i.name === exist.name ? { ...i, qty: i.qty + quantity } : i
        );
      }

      return [...prev, { id: Date.now(), name: product, qty: quantity }];
    });

    setProduct("");
    setQuantity(1);
  };

  // ---------- QTY ----------
  const inc = (id) =>
    setCart((prev) =>
      prev.map((i) => (i.id === id ? { ...i, qty: i.qty + 1 } : i))
    );

  const dec = (id) =>
    setCart((prev) =>
      prev
        .map((i) => (i.id === id ? { ...i, qty: i.qty - 1 } : i))
        .filter((i) => i.qty > 0)
    );

  const remove = (id) => setCart((prev) => prev.filter((i) => i.id !== id));

  const totalQty = useMemo(
    () => cart.reduce((sum, i) => sum + i.qty, 0),
    [cart]
  );

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        
        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-gray-800">POS Dashboard</h1>
          <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow">
            <FiShoppingCart />
            <span className="font-semibold">{cart.length} Items</span>
          </div>
        </div>

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
          {/* LEFT: ADD PRODUCT */}
          <div className="bg-white p-5 rounded-xl shadow border">
            <h2 className="text-lg font-semibold mb-4">Add Product</h2>

            <div className="space-y-4">
              <input
                value={product}
                onChange={(e) => setProduct(e.target.value)}
                placeholder="Product name"
                className="w-full border px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-400"
              />

              <div className="flex items-center gap-2">
                <button
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  className="p-2 bg-gray-100 rounded hover:bg-gray-200"
                >
                  <FiMinus />
                </button>

                <input
                  type="number"
                  min="1"
                  value={quantity}
                  onChange={(e) => setQuantity(Number(e.target.value))}
                  className="w-full border px-3 py-2 rounded-lg text-center"
                />

                <button
                  onClick={() => setQuantity((q) => q + 1)}
                  className="p-2 bg-gray-100 rounded hover:bg-gray-200"
                >
                  <FiPlus />
                </button>
              </div>

              <button
                onClick={addToCart}
                className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 font-semibold"
              >
                Add to Cart
              </button>
            </div>
          </div>

          {/* RIGHT: CART */}
          <div className="lg:col-span-2 bg-white rounded-xl shadow border">
            
            {/* CART HEADER */}
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="font-semibold text-lg">Cart</h2>
              <span className="text-sm text-gray-500">
                Total Qty: {totalQty}
              </span>
            </div>

            {/* CART BODY */}
            {cart.length === 0 ? (
              <div className="p-6 text-center text-gray-500">
                No items in cart
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50 text-gray-600">
                    <tr>
                      <th className="p-3 text-left">Product</th>
                      <th className="p-3 text-center">Qty</th>
                      <th className="p-3 text-right">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {cart.map((item) => (
                      <tr key={item.id} className="border-t">
                        <td className="p-3 font-medium text-gray-800">
                          {item.name}
                        </td>

                        <td className="p-3 text-center">
                          <div className="flex justify-center items-center gap-2">
                            <button onClick={() => dec(item.id)}>
                              <FiMinus />
                            </button>

                            <span className="w-6 text-center">
                              {item.qty}
                            </span>

                            <button onClick={() => inc(item.id)}>
                              <FiPlus />
                            </button>
                          </div>
                        </td>

                        <td className="p-3 text-right">
                          <button
                            onClick={() => remove(item.id)}
                            className="text-red-500 hover:text-red-700"
                          >
                            <FiTrash2 />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* FOOTER */}
            {cart.length > 0 && (
              <div className="flex justify-between items-center p-4 border-t">
                <span className="font-semibold text-gray-700">
                  Total Items: {cart.length}
                </span>

                <button
                  onClick={() => setCart([])}
                  className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
                >
                  Clear Cart
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}